<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp"> </p>
<p class="DED"><span epub:type="pagebreak" id="pg_v" title="v"><span class="ePub-I">For my father,</span></span></p>
<p class="DED"><span class="ePub-I">William Andrew Dillard,</span></p>
<p class="DED"><span class="ePub-I">Who loved in secret from afar</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4d2e3948